<template>
  <div ref="viewport" class="demo-screen-viewport" :style="{ aspectRatio: `${width}/${height}` }" :class="{ 'is-phone': compact }" aria-hidden="true">
    <iframe inert v-if="active" ref="frame" src="/archive-preview.html" :title="compact ? 'Phone preview' : 'Desktop preview'" tabindex="-1" :style="{ width: `${width}px`, height: `${height}px`, transform: `scale(${scale})`, borderRadius: compact ? `${19 / scale}px` : '0', clipPath: compact ? `inset(0 round ${19 / scale}px)` : 'none' }" />
    <!-- Keep a hit target in the host page from the first render. An inert
         ancestor would disable this surface along with the preview. -->
    <span class="demo-screen-input-surface"></span>
  </div>
</template>
<script>
import { accessViewport } from '../../utils/siteAccessDemo';
export default {
  name: 'ArchiveDemoScreen',
  props: { active: Boolean, compact: Boolean, landscape: Boolean, exhibition: Boolean, visible: Boolean, scene: String, state: Object, playing: Boolean, reducedMotion: Boolean },
  emits: ['ready', 'gallery-ready', 'scene-ready'],
  data: () => ({ scale: 1, ready: false, dark: false }),
  computed: {
    dimensions() { return accessViewport(this.compact ? 'phone' : 'desktop', this.landscape ? 'landscape' : 'portrait'); },
    width() { return this.dimensions.width; },
    height() { return this.dimensions.height; },
  },
  watch: { dimensions() { this.$nextTick(() => { this.resize(); this.sendFrame(true); }); }, exhibition() { this.sendFrame(true); }, visible() { this.sendFrame(true); }, state() { this.sendFrame(); }, playing() { this.sendFrame(true); }, dark() { this.sendFrame(true); }, scale() { this.sendFrame(true); } },
  mounted() {
    this._resize = new ResizeObserver(this.resize); this._resize.observe(this.$refs.viewport); this.resize();
    this._onMessage = event => {
      if (event.source !== this.$refs.frame?.contentWindow || event.origin !== location.origin) return;
      if (event.data?.type === 'archive-preview-gallery-ready') this.$emit('gallery-ready');
      if (event.data?.type === 'archive-preview-scene-ready') this.$emit('scene-ready', event.data.scene);
      if (event.data?.type === 'archive-preview-ready') { this.ready = true; this.sendFrame(true); this.$emit('ready'); }
    };
    window.addEventListener('message', this._onMessage);
    const syncTheme = () => { this.dark = document.body.classList.contains('dark-mode'); };
    this._theme = new MutationObserver(syncTheme); this._theme.observe(document.body, { attributes: true, attributeFilter: ['class'] }); syncTheme();
  },
  beforeUnmount() { this._resize?.disconnect(); this._theme?.disconnect(); window.removeEventListener('message', this._onMessage); },
  methods: {
    resize(entries) {
      const width = entries?.[0]?.contentRect.width ?? this.$refs.viewport?.getBoundingClientRect().width;
      if (width > 0) this.scale = width / this.width;
    },
    sendFrame(force = false) {
      if (!this.ready) return;
      const now = performance.now();
      if (!force && now - (this._lastSent || 0) < (this.scene === 'gallery' ? 12 : 30)) return;
      this._lastSent = now;
      this.$refs.frame.contentWindow.postMessage({ type: 'archive-preview-frame', scene: this.scene, exhibition: this.active && (['exhibition', 'access-exhibition'].includes(this.scene) || this.scene === 'home' && this.visible), touch: this.compact, elapsed: this.state.time, playing: this.playing, dark: this.dark, reducedMotion: this.reducedMotion, cornerRadius: this.compact ? 19 / this.scale : 0 }, location.origin);
    },
  },
};
</script>
<style scoped>
.demo-screen-viewport { position:relative; isolation:isolate; width:100%; aspect-ratio:1440/920; overflow:hidden; background:var(--demo-paper,#fff); touch-action:pan-y pinch-zoom; user-select:none; }
.demo-screen-viewport.is-phone { aspect-ratio:390/780; }
iframe { position:absolute; top:0; left:0; border:0; transform-origin:top left; pointer-events:none; }
.demo-screen-input-surface { position:absolute; inset:0; z-index:1; pointer-events:auto; touch-action:pan-y pinch-zoom; }
</style>
